import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Style, Settings } from '../../model/settings.model';
import { ParametersService } from '../../service/parameters.service';
import { FormControl } from '@angular/forms';
import { ToastService } from '../../service/toast.service';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-parameters-style',
  templateUrl: './parameters-style.component.html',
  styleUrls: ['./parameters-style.component.less']
})
export class ParametersStyleComponent implements OnInit {

  @Input() settings: Settings;
  @Input() company: boolean;

  timerEvent: NodeJS.Timer;
  damageColor: string;
  newDamageColor: string;
  @ViewChild('contentDashboard') content: ElementRef;
  isOpen: boolean;
  modalRef: NgbModalRef;
  closeResult: string;
  dashboardList: any
  listDashboard = [
    {
      display: this.i18n({
        id: 'picture',
        value: 'Photo Miniature',
        description: 'Photo Miniature',
        meaning: "contentDashboard"
      }), value: 'picture'
    },
    {
      display: this.i18n({
        id: 'speed',
        value: 'Speed',
        description: 'Speed',
        meaning: "contentDashboard"
      }), value: 'speed'
    },
    {
      display: this.i18n({
        id: 'matriculation',
        value: 'Immatriculation du vehicule',
        description: 'Immatriculation du vehicule',
        meaning: "contentDashboard"
      }), value: 'matriculation'
    },
    {
      display: this.i18n({
        id: 'damage',
        value: 'Nombre de Dommages',
        description: 'Nombre de Dommages',
        meaning: "contentDashboard"
      }), value: 'damage'
    },
    {
      display: this.i18n({
        id: 'newDamage',
        value: 'Nombre nouveaux de Dommages',
        description: 'Nombre nouveaux de Dommages',
        meaning: "contentDashboard"
      }), value: 'newDamage'
    },
    {
      display: this.i18n({
        id: 'status',
        value: 'Statut du Tchek',
        description: 'Statut du Tchek',
        meaning: "contentDashboard"
      }), value: 'status'
    },
    {
      display: this.i18n({
        id: 'brand',
        value: 'Marque du vehicule',
        description: 'Marque du vehicule',
        meaning: "contentDashboard"
      }), value: 'brand'
    },
    {
      display: this.i18n({
        id: 'model',
        value: 'Modèle du vehicule',
        description: 'Modèle du vehicule',
        meaning: "contentDashboard"
      }), value: 'model'
    },
    {
      display: this.i18n({
        id: 'fre',
        value: 'Frais de remise en état',
        description: 'Frais de remise en état',
        meaning: "contentDashboard"
      }), value: 'fre'
    },
    {
      display: this.i18n({
        id: 'newFre',
        value: 'Nouveaux Frais de remise en état',
        description: 'Nouveaux Frais de remise en état',
        meaning: "contentDashboard"
      }), value: 'newFre'
    },
    {
      display: this.i18n({
        id: 'date',
        value: 'Date du tchek',
        description: 'Date du tchek',
        meaning: "contentDashboard"
      }), value: 'date'
    },
    {
      display: this.i18n({
        id: 'scanner',
        value: 'Identifiant de la borne',
        description: 'Identifiant de la borne',
        meaning: "contentDashboard"
      }), value: 'scanner'
    }
  ];

  defaultDashboard = [
    {
      display: this.i18n({
        id: 'picture',
        value: 'Photo Miniature',
        description: 'Photo Miniature',
        meaning: "contentDashboard"
      }), value: 'picture'
    },
    {
      display: this.i18n({
        id: 'matriculation',
        value: 'Immatriculation du vehicule',
        description: 'Immatriculation du vehicule',
        meaning: "contentDashboard"
      }), value: 'matriculation'
    },
    {
      display: this.i18n({
        id: 'newDamage',
        value: 'Nombre nouveaux de Dommages',
        description: 'Nombre nouveaux de Dommages',
        meaning: "contentDashboard"
      }), value: 'newDamage'
    },
    {
      display: this.i18n({
        id: 'status',
        value: 'Statut du Tchek',
        description: 'Statut du Tchek',
        meaning: "contentDashboard"
      }), value: 'status'
    },
    {
      display: this.i18n({
        id: 'brand',
        value: 'Marque du vehicule',
        description: 'Marque du vehicule',
        meaning: "contentDashboard"
      }), value: 'brand'
    },
    {
      display: this.i18n({
        id: 'model',
        value: 'Modèle du vehicule',
        description: 'Modèle du vehicule',
        meaning: "contentDashboard"
      }), value: 'model'
    },
    {
      display: this.i18n({
        id: 'fre',
        value: 'Frais de remise en état',
        description: 'Frais de remise en état',
        meaning: "contentDashboard"
      }), value: 'fre'
    }]


  open(content: any) {
    this.isOpen = true;
    this.modalRef = this.modalService.open(content, { backdropClass: 'backdropClassModal' });
    this.modalRef.result.then((result) => {
      this.isOpen = false;
      this.settings.style.dashboard = this.dashboardList[2];
      this.sendData()
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.isOpen = false;
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  constructor(private modalService: NgbModal,
    private readonly i18n: I18n,
    private readonly _parametersService: ParametersService,
    private readonly _toastService: ToastService) {
    this.isOpen = false;


    if (this._parametersService.isSuperAdmin) {
      this.listDashboard.push(
        {
          display: this.i18n({
            id: 'type',
            value: 'Type de tchek',
            description: 'Type de tchek',
            meaning: "tchekType"
          }), value: 'type'
        })
    }
  }

  openModal(type: string) {
    console.log(this.dashboardList);
    this.dashboardList = [
      this.listDashboard,
      [],
      []
    ];

    if (this.settings && this.settings.vehicle) {
      if (this.settings.vehicle.orNumber && this.dashboardList[0].findIndex(c => (c.value === 'orNumber')) === -1)
        this.dashboardList[0].push({
          display: this.i18n({
            id: 'orNumber',
            value: 'Numero O.R.',
            description: 'Numero O.R.',
            meaning: "contentDashboard"
          }), value: 'orNumber'
        })
      if (this.settings.vehicle.vinNumber && this.dashboardList[0].findIndex(c => (c.value === 'vinNumber')) === -1)
        this.dashboardList[0].push({
          display: this.i18n({
            id: 'vinNumber',
            value: 'Numero de V.I.N.',
            description: 'Numero de V.I.N.',
            meaning: "contentDashboard"
          }), value: 'vinNumber'
        })
    }
    this.settings.style.dashboard.forEach(e => {
      this.dashboardList[2].push(e)
    });
    this.dashboardList[0].forEach(e => {
      if (this.dashboardList[2].findIndex(c => (c.display === e.display)) === -1)
        this.dashboardList[1].push(e)
    });

    if (type === 'dashboard' && this.isOpen === false)
      this.open(this.content)
  }

  resetDashboard() {
    this.dashboardList = [
      this.listDashboard,
      [],
      []
    ];

    if (this.settings && this.settings.vehicle) {
      if (this.settings.vehicle.orNumber && this.dashboardList[0].findIndex(c => (c.value === 'orNumber')) === -1)
        this.dashboardList[0].push({
          display: this.i18n({
            id: 'orNumber',
            value: 'Numero O.R.',
            description: 'Numero O.R.',
            meaning: "contentDashboard"
          }), value: 'orNumber'
        })
      if (this.settings.vehicle.vinNumber && this.dashboardList[0].findIndex(c => (c.value === 'vinNumber')) === -1)
        this.dashboardList[0].push({
          display: this.i18n({
            id: 'vinNumber',
            value: 'Numero de V.I.N.',
            description: 'Numero de V.I.N.',
            meaning: "contentDashboard"
          }), value: 'vinNumber'
        })
    }
    this.defaultDashboard.forEach(e => {
      this.dashboardList[2].push(e)
    });
    this.dashboardList[0].forEach(e => {
      if (this.dashboardList[2].findIndex(c => (c.display === e.display)) === -1)
        this.dashboardList[1].push(e)
    });

  }

  ngOnInit() {
    this.newDamageColor = this.settings.style.newDamageColor;
    this.damageColor = this.settings.style.damageColor
  }

  sendData() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._parametersService.saveStyle(this.settings.style, this.company).then((saved: Settings) => {
        this.settings.style = saved.style;
        this._toastService.toastOpen(false);
      });
    }, 500);
  }

  changeColor(event) {
    this.settings.style.damageColor = this.damageColor;
    this.settings.style.newDamageColor = this.newDamageColor;
    setTimeout(() => {
      this.sendData()
    }, 100);
  }

  removeItem(item: any, list: any[]): void {
    list.splice(list.indexOf(item), 1);
  }


}



// WEBPACK FOOTER //
// ./src/app/element/parameters-style/parameters-style.component.ts